import {
  EXPORT_JOB_START,
  EXPORT_JOB_PROGRESS,
  EXPORT_JOB_COMPLETE,
  EXPORT_JOB_CANCEL,
  EXPORT_JOB_ERROR,
  EXPORT_JOB_RESET,
} from "../actions/ExportActions";

const initialState = {
  jobId: null,
  status: "idle", // idle | starting | pending | fetching | processing | uploading | completed | cancelled | error
  progress: { current: 0, total: 0, phase: "" },
  url: null,
  error: null,
  format: "csv",
  requestedCount: 1000,
};

export default function exportReducer(state = initialState, action) {
  switch (action.type) {
    case EXPORT_JOB_START:
      return {
        ...initialState,
        status: "starting",
        format: action.payload.format || "csv",
        requestedCount: action.payload.requestedCount || 1000,
      };

    case EXPORT_JOB_PROGRESS:
      return {
        ...state,
        jobId: action.payload.jobId || state.jobId,
        status: action.payload.status || state.status,
        progress: action.payload.progress || state.progress,
      };

    case EXPORT_JOB_COMPLETE:
      return {
        ...state,
        jobId: action.payload.jobId || state.jobId,
        status: "completed",
        url: action.payload.url,
        progress: action.payload.progress || state.progress,
      };

    case EXPORT_JOB_CANCEL:
      return {
        ...state,
        status: "cancelled",
      };

    case EXPORT_JOB_ERROR:
      return {
        ...state,
        status: "error",
        error: action.payload.error,
      };

    case EXPORT_JOB_RESET:
      return { ...initialState };

    default:
      return state;
  }
}
